import { SheetFrame } from '../../design-system';
import { SleekButton } from '../../theme';

type Props = {
  vaulting: boolean;
  onCloseAndVault: () => void;
  onContinue: () => void;
};

const TITLE_ID = 'unopened-packs-sheet-title';

/**
 * Asked when the player leaves the reveal with packs of the order still
 * sealed (partner feedback 2026-10-01): close and vault them, or keep
 * ripping. Swiping the sheet away or the host back = keep ripping. One
 * general message (partner Loom 2026-10-14): besides the sealed packs there
 * may be a revealed card still waiting for Vault / Sell.
 */
export function UnopenedPacksSheet({ vaulting, onCloseAndVault, onContinue }: Props) {
  return (
    <SheetFrame
      onClose={onContinue}
      ariaLabelledBy={TITLE_ID}
      inspectName="RevealExitSheet"
      panelClassName="bg-[var(--co-RevealExitSheet-background,#0E0F11)] [border-top-left-radius:var(--co-RevealExitSheet-borderRadius,24px)] [border-top-right-radius:var(--co-RevealExitSheet-borderRadius,24px)]"
      handleClassName="bg-[var(--co-RevealExitSheet-handle,#2F3037)]"
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <h2 id={TITLE_ID} className="text-[20px] font-semibold leading-[26px] text-[var(--co-RevealExitSheet-text,#FFFFFF)]">
          Leave without finishing?
        </h2>
        <p className="max-w-[300px] text-[14px] leading-[20px] text-[var(--co-RevealExitSheet-mutedText,#6D707C)]">
          If you leave, your remaining cards and unopened packs will be added to your vault.
        </p>
      </div>
      <div className="mt-6 flex flex-col gap-3">
        <SleekButton name="RevealCloseAndVaultButton" onClick={onCloseAndVault} disabled={vaulting} className="w-full">
          {vaulting ? 'Vaulting…' : 'Close and vault'}
        </SleekButton>
        <SleekButton name="RevealContinueRippingButton" onClick={onContinue} disabled={vaulting} className="w-full">
          Continue
        </SleekButton>
      </div>
    </SheetFrame>
  );
}
